/* Laicai A-site checkout bridge
 * File name in Shopify Assets: laicai-a-checkout.js
 * Reads Shopify cart.js, builds the checkout payload, then opens your embedded checkout.
 */
(function () {
  'use strict';

  var CHECKOUT_URL = "https://jerseyplanets.shop/a/checkouts/a_index.html?store=piginto";
  var STORE_SLUG = "piginto";
  var SHOPIFY_DOMAIN = "e5b1kn-uz.myshopify.com";
  var A_SITE_CONFIGURED_DOMAIN = "jerseyplanets.shop";
  var A_SITE_NAME = "jerseyplanets";
  var PAYLOAD_PARAM = "payload";
  var CURRENCY_PARAM = "currency";
  var OPEN_MODE = "iframe";
  var BOUND_ATTR = 'data-laicai-checkout-bound';
  var DIRECT_BOUND_ATTR = 'data-laicai-direct-checkout-bound';
  var activeCheckoutOverlayCloser = null;
  var checkoutRequestInFlight = false;
  var ATTRIBUTION_STORAGE_KEY = 'laicai:a-site-ad-attribution';
  var ATTRIBUTION_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var ATTRIBUTION_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'gclid',
    'gad_source',
    'gad_campaignid',
    'gclsrc',
    'gbraid',
    'wbraid',
    'fbclid',
    'fbc',
    'fbp',
    'ttclid',
    'ttp',
    'msclkid',
    'twclid'
  ];

  function normalizeUrl(value) {
    if (!value) return '';
    if (value.indexOf('//') === 0) return window.location.protocol + value;
    if (value.charAt(0) === '/') return window.location.origin + value;
    return value;
  }

  function encodePayload(payload) {
    var json = JSON.stringify(payload);
    var bytes = new TextEncoder().encode(json);
    var binary = '';
    bytes.forEach(function (byte) {
      binary += String.fromCharCode(byte);
    });
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function readCookieValue(name) {
    var prefix = name + '=';
    var parts = String(document.cookie || '').split(';');
    for (var index = 0; index < parts.length; index += 1) {
      var part = parts[index].trim();
      if (part.indexOf(prefix) === 0) return decodeURIComponent(part.slice(prefix.length));
    }
    return '';
  }

  function compactAttribution(data) {
    var compact = {};
    ATTRIBUTION_PARAMS.forEach(function (key) {
      var value = data && data[key];
      if (value) compact[key] = String(value).slice(0, 500);
    });
    return compact;
  }

  function readStoredAttribution() {
    try {
      if (!window.localStorage) return {};
      var raw = window.localStorage.getItem(ATTRIBUTION_STORAGE_KEY);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      var updatedAt = Number(parsed && parsed.updatedAt);
      if (!updatedAt || Date.now() - updatedAt > ATTRIBUTION_TTL_MS) return {};
      return compactAttribution(parsed.params || {});
    } catch (error) {
      return {};
    }
  }

  function writeStoredAttribution(params) {
    try {
      if (!window.localStorage) return;
      var compact = compactAttribution(params);
      if (!Object.keys(compact).length) return;
      window.localStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify({
        updatedAt: Date.now(),
        params: compact
      }));
    } catch (error) {
      // Ignore storage errors so checkout buttons keep working in privacy mode.
    }
  }

  function collectAttribution() {
    var params = readStoredAttribution();
    var query = new URLSearchParams(window.location.search);

    ATTRIBUTION_PARAMS.forEach(function (key) {
      var value = query.get(key);
      if (value) params[key] = value;
    });

    var fbp = readCookieValue('_fbp');
    var fbc = readCookieValue('_fbc');
    var ttp = readCookieValue('_ttp');
    if (fbp) params.fbp = fbp;
    if (fbc) params.fbc = fbc;
    if (ttp) params.ttp = ttp;
    if (!params.fbc && params.fbclid) {
      params.fbc = 'fb.1.' + Math.floor(Date.now() / 1000) + '.' + params.fbclid;
    }

    params = compactAttribution(params);
    if (Object.keys(params).length) writeStoredAttribution(params);
    return params;
  }

  function appendAttributionToUrl(rawUrl, attribution) {
    try {
      var url = new URL(rawUrl, window.location.origin);
      Object.keys(attribution || {}).forEach(function (key) {
        if (!url.searchParams.get(key)) url.searchParams.set(key, attribution[key]);
      });
      return url.toString();
    } catch (error) {
      return rawUrl;
    }
  }

  function appendAttributionParams(url, attribution) {
    Object.keys(attribution || {}).forEach(function (key) {
      if (attribution[key]) url.searchParams.set(key, attribution[key]);
    });
  }

  function cartCurrency(cart) {
    return String(
      cart.currency ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'USD'
    ).toUpperCase();
  }

  function parseMoneyToCents(value) {
    var text = String(value || '').replace(/,/g, '').trim();
    if (!text) return null;
    var match = text.match(/-?\d+(?:\.\d{1,2})?/);
    if (!match) return null;
    var amount = Number(match[0]);
    if (!Number.isFinite(amount) || amount <= 0) return null;
    return Math.round(amount * 100);
  }

  function findLabelForInput(root, input) {
    if (!root || !input) return null;
    if (input.id) {
      var labels = root.querySelectorAll('label[for]');
      for (var index = 0; index < labels.length; index += 1) {
        if (labels[index].getAttribute('for') === input.id) return labels[index];
      }
    }
    var sibling = input.nextElementSibling;
    if (sibling && sibling.matches && sibling.matches('label.quantity-break, .quantity-break')) return sibling;
    return input.closest && input.closest('.quantity-break');
  }

  function findCheckoutScope(button, form) {
    return (
      (form && form.closest('section[id^="shopify-section-"], section[id^="MainProduct-"], .product, .featured-product, main')) ||
      (button && button.closest('section[id^="shopify-section-"], section[id^="MainProduct-"], .product, .featured-product, main')) ||
      document
    );
  }

  function parseBundleQuantity(selectedBreak) {
    if (!selectedBreak) return 1;
    var attrs = ['data-quantity', 'data-qty', 'data-bundle-quantity', 'data-items', 'data-count'];
    for (var index = 0; index < attrs.length; index += 1) {
      var value = Number(selectedBreak.getAttribute(attrs[index]));
      if (Number.isFinite(value) && value > 0 && value < 1000) return Math.floor(value);
    }

    var text = String(selectedBreak.textContent || '').replace(/\s+/g, ' ').trim();
    var patterns = [
      /(?:buy|get|pack|bundle)\s*(\d+)/i,
      /(\d+)\s*(?:pcs?|pieces?|pack|packs|items?|bottles?|boxes?)/i
    ];
    for (var patternIndex = 0; patternIndex < patterns.length; patternIndex += 1) {
      var match = text.match(patterns[patternIndex]);
      var parsed = match ? Number(match[1]) : 0;
      if (Number.isFinite(parsed) && parsed > 0 && parsed < 1000) return Math.floor(parsed);
    }

    return 1;
  }

  function findBundlePriceCents(selectedBreak) {
    if (!selectedBreak || !selectedBreak.querySelectorAll) return null;
    var selectors = [
      '[data-text="[price]"]',
      '[data-bundle-price]',
      '[data-price]',
      '.quantity-break__price',
      '.quantity-break__final-price',
      '.quantity-break__sale-price',
      '.bundle-price',
      '.bundle__price',
      '.bundle-price__price'
    ];

    for (var selectorIndex = 0; selectorIndex < selectors.length; selectorIndex += 1) {
      var nodes = selectedBreak.querySelectorAll(selectors[selectorIndex]);
      for (var nodeIndex = 0; nodeIndex < nodes.length; nodeIndex += 1) {
        var node = nodes[nodeIndex];
        var rawValue = node.getAttribute('data-bundle-price') || node.getAttribute('data-price') || node.textContent || '';
        var text = String(rawValue).trim();
        var looksLikeMoney = /[$€£¥]|\b(?:USD|EUR|GBP|CAD|AUD)\b|\d+\.\d{2}/i.test(text);
        var cents = parseMoneyToCents(text);
        if (cents && looksLikeMoney) return cents;
      }
    }

    return null;
  }

  function readSelectedBundleOverride(button, form) {
    var root = findCheckoutScope(button, form);
    if (!root || !root.querySelector) return null;
    var selectedInput = root.querySelector('quantity-breaks input[type="radio"]:checked, .quantity-breaks input[type="radio"]:checked');
    var selectedBreak = findLabelForInput(root, selectedInput);

    if (!selectedBreak) {
      var candidates = root.querySelectorAll('label.quantity-break, .quantity-break');
      for (var index = 0; index < candidates.length; index += 1) {
        var candidate = candidates[index];
        var checked = candidate.matches('.selected, .active, [aria-checked="true"], [data-selected="true"]') ||
          candidate.className && String(candidate.className).indexOf('selected') >= 0;
        if (checked) {
          selectedBreak = candidate;
          break;
        }
      }
    }

    if (!selectedBreak) return null;
    var linePriceCents = findBundlePriceCents(selectedBreak);
    if (!linePriceCents) return null;

    var quantity = parseBundleQuantity(selectedBreak);

    return {
      quantity: quantity,
      subtotalCents: linePriceCents,
      source: 'quantity-breaks'
    };
  }

  function applyBundleOverrideToPayload(payload, override) {
    if (!payload || !override || !override.subtotalCents || !(payload.i || []).length) return payload;
    payload.subtotalCents = override.subtotalCents;
    payload.amountCents = override.subtotalCents;
    payload.bundleSource = override.source || 'page';

    if (payload.i.length === 1 && override.quantity > 0) {
      payload.i[0].qty = override.quantity;
      payload.i[0].price = Math.max(0, Math.round(override.subtotalCents / override.quantity));
    }

    return payload;
  }

  function buildPayload(cart, bundleOverride) {
    var currency = cartCurrency(cart);
	    var payload = {
	      c: currency,
	      priceUnit: 'minor',
	      i: (cart.items || []).map(function (item) {
	        var image = item.image || (item.featured_image && item.featured_image.url) || '';
	        return {
	          sku: item.sku || '',
	          vid: String(item.variant_id || item.id || ''),
	          pid: String(item.product_id || ''),
	          title: item.product_title || item.title || 'Item',
	          qty: Math.max(1, Number(item.quantity || 1)),
	          price: Math.max(0, Number(item.final_price || item.price || 0)),
	          priceUnit: 'minor',
	          imageUrl: normalizeUrl(image)
	        };
	      })
	    };
    return applyBundleOverrideToPayload(payload, bundleOverride);
  }

  function buildCheckoutUrl(payload, cart) {
    var url = new URL(CHECKOUT_URL, window.location.origin);
    var currency = cartCurrency(cart);
    var attribution = collectAttribution();
    var sourceUrl = appendAttributionToUrl(window.location.href, attribution);
    url.searchParams.set(PAYLOAD_PARAM, encodePayload(payload));
    url.searchParams.set(CURRENCY_PARAM, currency);
    url.searchParams.set('source', 'shopify-a-site');
    url.searchParams.set('source_url', sourceUrl);
    url.searchParams.set('return_url', window.location.href);
    url.searchParams.set('shop', SHOPIFY_DOMAIN || (window.Shopify && window.Shopify.shop) || window.location.hostname);
    url.searchParams.set('a_site_domain', window.location.hostname);
    url.searchParams.set('embed', 'shopify');
    url.searchParams.set('open_mode', OPEN_MODE);
    url.searchParams.set('a_site_name', A_SITE_NAME);
    if (A_SITE_CONFIGURED_DOMAIN) url.searchParams.set('configured_a_site_domain', A_SITE_CONFIGURED_DOMAIN);
    appendAttributionParams(url, attribution);
    if (STORE_SLUG) url.searchParams.set('store', STORE_SLUG);
    if (cart.token) url.searchParams.set('cart_id', cart.token);
    return url.toString();
  }

  function openInIframe(url) {
    if (activeCheckoutOverlayCloser) {
      activeCheckoutOverlayCloser();
      activeCheckoutOverlayCloser = null;
    } else {
      var old = document.getElementById('laicai-a-checkout-overlay');
      if (old) old.remove();
    }
    function closeOverlay() {
      var current = document.getElementById('laicai-a-checkout-overlay');
      if (current) current.remove();
      if (activeCheckoutOverlayCloser === closeOverlay) {
        activeCheckoutOverlayCloser = null;
      }
    }

    var overlay = document.createElement('div');
    overlay.id = 'laicai-a-checkout-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.45);';

    var panel = document.createElement('div');
    panel.style.cssText = 'position:absolute;inset:0;background:#fff;overflow:hidden;';

    var close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close checkout');
    close.textContent = '×';
    close.style.cssText = 'position:absolute;right:14px;top:12px;z-index:2;width:38px;height:38px;border:0;border-radius:999px;background:rgba(0,0,0,.08);font-size:28px;line-height:1;cursor:pointer;';

    var loader = document.createElement('div');
    loader.setAttribute('aria-live', 'polite');
    loader.style.cssText = 'position:absolute;inset:0;z-index:1;display:flex;align-items:center;justify-content:center;background:#fff;color:#333;font:500 14px/1.4 -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;';
    loader.textContent = 'Loading checkout...';

    var frame = document.createElement('iframe');
    frame.src = url;
    frame.title = 'Secure checkout';
    frame.allow = 'payment *; clipboard-read; clipboard-write';
    frame.style.cssText = 'width:100%;height:100%;border:0;background:#fff;opacity:0;transition:opacity .16s ease;';
    frame.addEventListener('load', function () {
      frame.style.opacity = '1';
      if (loader.parentNode) loader.parentNode.removeChild(loader);
    });
    window.setTimeout(function () {
      frame.style.opacity = '1';
      if (loader.parentNode) loader.parentNode.removeChild(loader);
    }, 8000);

    close.addEventListener('click', closeOverlay);

    activeCheckoutOverlayCloser = closeOverlay;
    panel.appendChild(close);
    panel.appendChild(loader);
    panel.appendChild(frame);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);
  }

  function openCheckout(url) {
    if (OPEN_MODE === 'iframe') {
      openInIframe(url);
      return;
    }

    if (OPEN_MODE === 'popup') {
      var popup = window.open(url, 'laicaiCheckout', 'width=520,height=820,noopener,noreferrer');
      if (!popup) window.location.href = url;
      return;
    }

    window.location.href = url;
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    if (activeCheckoutOverlayCloser) {
      activeCheckoutOverlayCloser();
      activeCheckoutOverlayCloser = null;
    } else {
      var overlay = document.getElementById('laicai-a-checkout-overlay');
      if (overlay) overlay.remove();
    }
  });

  function setLoading(button, loading) {
    if (!button) return;
    var isInputButton = button.tagName === 'INPUT';
    if (loading) {
      button.setAttribute('aria-busy', 'true');
      if (!button.dataset.laicaiOriginalHtml) {
        button.dataset.laicaiOriginalHtml = isInputButton ? (button.value || '') : button.innerHTML;
      }
      if (isInputButton) {
        button.value = 'Loading...';
      } else {
        var label = button.querySelector('.button__label, .main-atc__label__text, .sticky-atc__label__text');
        if (label) label.textContent = 'Loading...';
        else button.textContent = 'Loading...';
      }
    } else {
      button.removeAttribute('aria-busy');
      var original = button.dataset.laicaiOriginalHtml;
      if (original) {
        if (isInputButton) button.value = original;
        else button.innerHTML = original;
        delete button.dataset.laicaiOriginalHtml;
      }
    }
  }

  async function readJsonResponse(response, fallbackMessage) {
    var text = '';
    try {
      text = await response.text();
      if (text) {
        var json = JSON.parse(text);
        if (json && (json.message || json.description || json.status)) {
          return {
            ok: response.ok,
            data: json,
            message: json.description || json.message || fallbackMessage
          };
        }
        return { ok: response.ok, data: json, message: fallbackMessage };
      }
    } catch (error) {
      // Keep the original fallback message when Shopify returns non-JSON HTML.
    }
    return { ok: response.ok, data: null, message: text || fallbackMessage };
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function fullyStopCheckoutEvent(event) {
    if (!event) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) {
      event.stopImmediatePropagation();
    }
  }

  async function readCart() {
    var response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  }

  async function readCartForCheckout(expectedVariantId) {
    var lastCart = null;
    for (var attempt = 0; attempt < 4; attempt += 1) {
      if (attempt > 0) await wait(180 * attempt);
      lastCart = await readCart();
      if (!expectedVariantId) return lastCart;
      var items = lastCart.items || [];
      var found = items.some(function (item) {
        return String(item.variant_id || item.id || '') === String(expectedVariantId);
      });
      if (found || items.length > 0) return lastCart;
    }
    return lastCart || readCart();
  }

  async function openCartCheckout(expectedVariantId, bundleOverride) {
    var cart = await readCartForCheckout(expectedVariantId);
    var payload = buildPayload(cart, bundleOverride);
    if (!payload.i.length) throw new Error('Cart is empty after add');

    openCheckout(buildCheckoutUrl(payload, cart));
  }

  function findProductForm(button) {
    if (!button) return document.querySelector('form[action*="/cart/add"]');

    var formId = button.getAttribute('form');
    if (formId) {
      var formById = document.getElementById(formId);
      if (formById && formById.matches('form[action*="/cart/add"]')) return formById;
    }

    var productForm = button.closest('product-form');
    if (productForm) {
      var nestedForm = productForm.querySelector('form[action*="/cart/add"]');
      if (nestedForm) return nestedForm;
    }

    var scopedRoot = button.closest('quick-add-modal, section[id^="MainProduct-"], section[id^="shopify-section-"], .product, .featured-product');
    if (scopedRoot) {
      var scopedForm = scopedRoot.querySelector('form[action*="/cart/add"]');
      if (scopedForm) return scopedForm;
    }

    var closestForm = button.closest('form[action*="/cart/add"]');
    if (closestForm) return closestForm;

    if (
      button.matches('[data-laicai-direct-checkout-button], .shopify-payment-button__button') ||
      button.getAttribute('data-skip-cart-button') === 'true'
    ) {
      return document.querySelector('product-form[data-main="true"] form[action*="/cart/add"], form[action*="/cart/add"]');
    }

    return null;
  }

  function productFormHasSkipCartIntent(form) {
    return !!(form && form.querySelector('[data-skip-cart="true"], [data-skip-cart-button="true"]'));
  }

  function shouldUseDirectProductCheckout(button) {
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return false;
    if (button.matches('[data-laicai-direct-checkout-button], .shopify-payment-button__button')) return true;
    if (button.getAttribute('data-skip-cart-button') === 'true') return true;
    if (button.id && button.id.indexOf('SectionAtcBtn-') === 0 && findProductForm(button)) return true;
    var form = findProductForm(button);
    return productFormHasSkipCartIntent(form);
  }

  async function addCurrentProductToCart(button, form, bundleOverride) {
    form = form || findProductForm(button);
    if (!form) throw new Error('Product form not found');

    var formData = new FormData(form);
    if (!formData.get('id')) {
      var variantInput = form.querySelector('[name="id"]') || document.querySelector('[name="id"]');
      if (variantInput && variantInput.value) formData.set('id', variantInput.value);
    }
    var variantId = formData.get('id');
    if (!variantId) throw new Error('Variant id not found');
    if (!formData.get('quantity')) {
      var quantityInput = form.querySelector('[name="quantity"]');
      formData.set('quantity', quantityInput && quantityInput.value ? quantityInput.value : '1');
    }
    if (bundleOverride && bundleOverride.quantity) {
      formData.set('quantity', String(bundleOverride.quantity));
    }

    var response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    });

    if (!response.ok) {
      var parsed = await readJsonResponse(response, 'Unable to add product to cart');
      throw new Error(parsed.message || 'Unable to add product to cart');
    }
    return String(variantId);
  }

  async function startCheckout(event) {
    if (event.__laicaiCheckoutHandled) {
      fullyStopCheckoutEvent(event);
      return;
    }
    event.__laicaiCheckoutHandled = true;
    fullyStopCheckoutEvent(event);
    if (checkoutRequestInFlight) return;
    checkoutRequestInFlight = true;
    var button = event.currentTarget;

    try {
      setLoading(button, true);
      await openCartCheckout();
    } catch (error) {
      console.error('[Laicai checkout] cart checkout failed', error);
      alert('Checkout request failed. Please try again.');
    } finally {
      setLoading(button, false);
      checkoutRequestInFlight = false;
    }
  }

  async function startDirectProductCheckout(event) {
    if (event.__laicaiCheckoutHandled) {
      fullyStopCheckoutEvent(event);
      return;
    }
    event.__laicaiCheckoutHandled = true;
    var button = event.currentTarget;
    if (!shouldUseDirectProductCheckout(button)) return;
    fullyStopCheckoutEvent(event);
    if (checkoutRequestInFlight) return;
    var form = findProductForm(button);
    if (!form) {
      console.error('[Laicai checkout] direct product form not found', button);
      alert('Checkout request failed. Please try again.');
      return;
    }
    checkoutRequestInFlight = true;

    try {
      setLoading(button, true);
      var bundleOverride = readSelectedBundleOverride(button, form);
      var variantId = await addCurrentProductToCart(button, form, bundleOverride);
      await openCartCheckout(variantId, bundleOverride);
    } catch (error) {
      console.error('[Laicai checkout] direct product checkout failed', error);
      alert('Checkout request failed. Please try again.');
    } finally {
      setLoading(button, false);
      checkoutRequestInFlight = false;
    }
  }

  function bindButton(button) {
    if (!button || button.getAttribute(BOUND_ATTR) === '1') return;
    button.setAttribute(BOUND_ATTR, '1');
    button.addEventListener('click', startCheckout, true);
  }

  function bindDirectProductButton(button) {
    if (!button || button.getAttribute(DIRECT_BOUND_ATTR) === '1') return;
    button.setAttribute(DIRECT_BOUND_ATTR, '1');
    button.addEventListener('click', startDirectProductCheckout, true);
  }

  function bindCheckoutButtons() {
    var selectors = [
      '[data-laicai-checkout-button]',
      '.cart__checkout-button',
      '#CartDrawer-Checkout',
      'a[href="/checkout"]',
      'a[href^="/checkout?"]',
      'button[formaction="/checkout"]',
      'input[formaction="/checkout"]',
      'button[name="checkout"]',
      'input[name="checkout"]'
    ];
    var directProductSelectors = [
      '[data-laicai-direct-checkout-button]',
      'button[id^="SectionAtcBtn-"]',
      'form[action*="/cart/add"] button[name="add"]',
      'button[name="add"][data-skip-cart-button="true"]',
      'button[data-skip-cart-button="true"]',
      '.shopify-payment-button__button'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(bindButton);
    document.querySelectorAll(directProductSelectors.join(',')).forEach(bindDirectProductButton);
  }

  if (document.readyState === 'loading') {
    collectAttribution();
    document.addEventListener('DOMContentLoaded', bindCheckoutButtons);
  } else {
    collectAttribution();
    bindCheckoutButtons();
  }

  new MutationObserver(bindCheckoutButtons).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();